import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class DashboardRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param siteId
   * @param type
   */
  getAll(token: string, siteId: number, type: number) {
    let url = this.network.CodaQApi() + CQWebappApi.DASHBOARD;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.TYPE, type.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
